<template>
  <FieldValidator :name="name">
    <template v-slot="{ value, handleChange, isInvalid, errorMessage }">
      <RadioButton
        :name="radioName"
        :id="id"
        :binary="true"
        :modelValue="value"
        @update:modelValue="handleChange"
        :class="{ 'p-invalid': isInvalid }"
        :aria-labelledby="valueText ? `${id}-value-text` : undefined"
        v-bind="$attrs"
      >
        <template v-for="(_, slot) of $slots" v-slot:[slot]="scope">
          <slot v-if="slot" :name="slot" v-bind="scope" />
        </template>

        <template v-if="label" #label>{{ label }}</template>
        <template v-if="valueText" #valueText>{{ valueText }}</template>
        <template v-if="isInvalid" #helperText>{{ errorMessage }}</template>
      </RadioButton>
    </template>
  </FieldValidator>
</template>

<script setup lang="ts">
import { RadioButton } from '../../../core/controls';
import { FieldValidator } from '../field-validator';

defineProps({
  name: {
    type: String,
    required: true,
  },
  radioName: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
  id: {
    type: String,
    default: 'radio-button',
  },
  valueText: {
    type: String,
  },
});
</script>
